/* Keep Craft's focus trap and scroll lock in sync for homepage anchor links. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-solara-drawer-link]');
  if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const destination = new URL(link.href);
  if (destination.origin !== window.location.origin || !destination.hash || destination.pathname !== window.location.pathname) return;
  const target = document.getElementById(destination.hash.slice(1));
  const drawer = link.closest('header-drawer');
  if (!target || !drawer) return;
  const menuToggle = drawer.querySelector('summary');
  drawer.closeMenuDrawer(event, menuToggle);
  menuToggle.setAttribute('aria-expanded', 'false');
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
});
